
import { trackLoginImpression } from '@/plugins/hwtag/events'

export default {
    name: 'course',
    props: ['source', 'entry'],
    data() {
        return {

        }
    },
    computed: {
        entryParam() {
            if (this.entry) return this.entry
            return this.$route.query.entry || undefined
        }
    },
    methods:{
        handleCourseClick() {
            trackLoginImpression('点击', '课程访问', 'course view')
            const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == '1';
            if (useNewLogin) {
                this.$store.commit('OPEN_AUTH_MODAL', {
                    tab: 'login',
                    redirectToUserCenter: false,
                    source: { elementTypeName: '课程访问', clickName: 'course view' },
                });
            } else {
                this.$jumpTerminus(4, this.source.id)
            }
        }
    },
    watch: {
        source(val) {
            this.source = val
        }
    },
    filters: {
        format(date) {
            if (!date) return 'e';
            const dt = new Date(date * 1000);
            let y = dt.getFullYear(),
                m = dt.getMonth() + 1,
                d = dt.getDate(),
                h = dt.getHours(),
                mm = dt.getMinutes(),
                ss = dt.getSeconds();
            m = String(m).padStart(2, '0')
            d = String(d).padStart(2, '0')
            return y + '-' + m + '-' + d
        }
    }

}
